import * as ReactGA from 'react-ga';
import Logger from './logger';
import { Config } from '../config';

const DEBUG = false;
const log = new Logger('Analytics', DEBUG);

// ReactGA.initialize(Config.GA_TRACKING_ID);

const trackView = (view: string) => {
  log.info('Tracked page view:', view);
  ReactGA.set({ page: view });
  ReactGA.pageview(view);
};

/**
 * Tracking in-page event interactions
 * @param category A top level category for these events. E.g. 'User', 'Navigation', 'App Editing', etc.
 * @param action A description of the behaviour. E.g. 'Clicked Delete', 'Added a component', 'Deleted account', etc.
 * @param label More precise labelling of the related action. E.g. alongside the 'Added a component' action.
 * @param value A means of recording a numerical value against an event. E.g. a rating, a score, etc.
 */
const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  log.info('trackEvent', { category, action, label, value });
  ReactGA.event({ category, action, label, value });
};

export {
  trackView,
  trackEvent
};



// WEBPACK FOOTER //
// ./src/services/analytics.ts